// src/components/common/StackedBarChart.js
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const StackedBarChart = ({ labels, datasets, isDark = false, height = 280 }) => {
  const chartData = {
    labels,
    datasets: datasets.map((ds) => ({
      label: ds.label,
      data: ds.data,
      backgroundColor: ds.color,
      borderRadius: 6,
      maxBarThickness: 22,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: isDark ? "#c3c2b7" : "#898781" },
      },
      y: {
        grid: { color: isDark ? "#2c2c2a" : "#e1e0d9" },
        ticks: { color: isDark ? "#c3c2b7" : "#898781" },
        beginAtZero: true,
      },
    },
  };

  return (
    <>
      {/* Custom Legend */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          margin: "12px 0",
          fontSize: "13px",
          color: isDark ? "#c3c2b7" : "#898781",
        }}
      >
        {datasets.map((ds) => (
          <span key={ds.label} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "2px",
                backgroundColor: ds.color,
              }}
            ></span>
            {ds.label}
          </span>
        ))}
      </div>

      <div style={{ position: "relative", width: "100%", height }}>
        <Bar data={chartData} options={options} />
      </div>
    </>
  );
};

export default StackedBarChart;